module.exports = __webpack_public_path__ + "img/young.1ced79b2.jpg";